import { defineMessages } from 'react-intl';

export const cameraMessages = defineMessages({
    camera: {
        id: 'camera',
        defaultMessage: 'Camera',
    },
    cameraStream: {
        id: 'camera-stream',
        defaultMessage: 'Camera Stream',
    },
    cameraStreamForGateway: {
        id: 'camera-stream-for-gateway',
        defaultMessage: 'Camera stream for {gateway}',
    },
    streamUnavailableError: {
        id: 'custom-error:camera_stream_unavailable',
        defaultMessage: 'The stream is temporarily unavailable!',
    },
    cameraNotConfigured: {
        id: 'camera-not-configured',
        defaultMessage: 'The camera is not configured!',
    },
});
